import {
  faCube,
  faDesktop,
  faGear,
  faMobileScreen,
  faServer,
  faForward,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import React, { useContext, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { FaCode } from "react-icons/fa";
import VisibilitySensor from "react-visibility-sensor";
import angular from "../../assets/images/angular.png";
import bootstrap from "../../assets/images/bootstrap.png";
import cordova from "../../assets/images/cordova.png";
import csharp from "../../assets/images/csharp.png";
import docker from "../../assets/images/docker.png";
import aws from "../../assets/images/aws.png";
import express from "../../assets/images/express.png";
import flutter from "../../assets/images/flutter.png";
import git from "../../assets/images/git.png";
import java from "../../assets/images/java.png";
import jquery from "../../assets/images/jquery.png";
import js from "../../assets/images/js.png";
import kubernates from "../../assets/images/kubernates.png";
import laravel from "../../assets/images/laravel.png";
import wordpress from "../../assets/images/wordpress.png";
import tailwind from "../../assets/images/tailwind.png";
import symfony from "../../assets/images/symfony.png";
import mongodb from "../../assets/images/mongodb.png";
import mysql from "../../assets/images/mysql.png";
import next from "../../assets/images/next.png";
import node from "../../assets/images/node.png";
import php from "../../assets/images/php.png";
import plesk from "../../assets/images/plesk.png";
import python from "../../assets/images/python.png";
import react from "../../assets/images/react.png";
import spring from "../../assets/images/spring.png";
import three from "../../assets/images/three.png";
import ts from "../../assets/images/ts.png";
import unity from "../../assets/images/unity.png";
import { Context } from "../../context";
import Spacer from "../Utils/Spacer";
import CardSkill from "./CardSkill";
import classes from "./SkillPage.module.css";

const ContainerCardSkill = ({ children }) => {
  return (
    <div className={classes.ContainerCardSkill}>
      {children}
    </div>
  );
};

function SkillPage() {
  const [isVisible, setIsVisible] = useState(false);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const { debug, lang } = useContext(Context);

  return (
    <>
      <div className={classes.bg9}>
        {/* Simplified Header without Iframe */}
        <div className={classes.skillsTopContainer}>
          <div className={classes.textSkillsTop}>
            {/* Header Text */}
            <h1 className={classes.textSkillsTop1}>
              <FaCode /> <span>Programming Skills</span>
            </h1>

            {lang === "en" && (
              <p className={classes.textSkills}>
                Regardless of the technology used, I adapt to new languages,
                frameworks or techniques in a short time, respecting the
                team's guidelines. I attend many online courses that allow
                me to update or improve my knowledge. I'm generally quick to
                learn new technologies and be productive.
              </p>
            )}
            {lang === "it" && (
              <p className={classes.textSkills}>
                Indipendentemente dalla tecnologia utilizzata, mi adeguo a
                nuovi linguaggi, framework o tecniche in breve tempo,
                rispettando le linee guida del team. Frequento molti corsi
                online che mi permettono di aggiornare o migliorare le mie
                conoscenze. In genere sono veloce nell'apprendere nuove
                tecnologie ed essere produttivo.
              </p>
            )}
          </div>
        </div>

        <Spacer height={10} />

        {/* BACKEND SECTION */}
        <div className={classes.boxText}>
          <div className={classes.boxHeader}>
            <div className={classes.skillTitleBar}>
              <Container>
                <Row>
                  <div className={classes.titleSkill}>
                    <div className={classes.roundSkill}>
                      <FontAwesomeIcon icon={faServer} />
                    </div>
                    <div className={classes.titleText}>Backend</div>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.boxBody}>
            <Container>
              <Row>
                <Col xs={12} lg={12}>
                  <div className="col-12 text-justify text-lg-start pt-3 pb-1">
                    <p className={classes.textSkills}>
                      {lang === "en" ? (
                        <>
                          Experience with server-side programming languages such as Php, Node.js, Java.<br />
                          Knowledge of RESTful architectures and API for building scalable web services.<br />
                          Competence in using backend frameworks like Express, Laravel or Spring. Ability to manage relational databases (MySQL, PostgreSQL) and NoSQL databases (such as MongoDB).
                        </>
                      ) : (
                        <>
                          Esperienza con linguaggi di programmazione server-side come Php, Node.js, Java.<br />
                          Conoscenza delle architetture RESTful e API per la creazione di servizi web scalabili.<br />
                          Competenza nell'utilizzo di framework backend come Express, Laravel o Spring. Capacità di gestire database relazionali (MySQL, PostgreSQL) e database NoSQL (come MongoDB).
                        </>
                      )}
                    </p>
                  </div>

                  <VisibilitySensor onChange={changeVisibility} partialVisibility delayedCall>
                    <ContainerCardSkill>
                      <CardSkill text="php" classCard="php" img={php} />
                      <CardSkill text="laravel" classCard="laravel" img={laravel} />
                      <CardSkill text="symfony" classCard="symfony" img={symfony} />
                      <CardSkill text="mysql" classCard="mysql" img={mysql} />
                      <CardSkill text="node.js" classCard="node" img={node} />
                      <CardSkill text="express" classCard="express" img={express} />
                      <CardSkill text="mongo db" classCard="mongodb" img={mongodb} />
                      <CardSkill text="spring" classCard="spring" img={spring} />
                      <CardSkill text="python" classCard="python" img={python} />
                    </ContainerCardSkill>
                  </VisibilitySensor>

                  <Spacer height="30" />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        {/* FRONTEND SECTION */}
        <div className={classes.boxText}>
          <div className={classes.boxHeader}>
            <div className={classes.skillTitleBar}>
              <Container>
                <Row>
                  <div className={classes.titleSkill}>
                    <div className={classes.roundSkill}>
                      <FontAwesomeIcon icon={faDesktop} />
                    </div>
                    <div className={classes.titleText}>Frontend</div>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.boxBody}>
            <Container>
              <Row>
                <Col xs={12} lg={12}>
                  <div className="col-12 text-justify text-lg-start pt-3 pb-1">
                    <p className={classes.textSkills}>
                      {lang === "en" ? (
                        <>
                          Mastery of HTML, CSS and JavaScript for creating web pages, responsive user interfaces.<br />
                          Knowledge of frontend frameworks like React, Angular.<br />
                          Ability to manage application state using libraries such as Redux.
                        </>
                      ) : (
                        <>
                          Padronanza di HTML, CSS e JavaScript per la creazione di pagine web responsive.<br />
                          Conoscenza dei framework frontend come React, Angular.<br />
                          Abilità nella gestione dello stato dell'applicazione utilizzando librerie come Redux.
                        </>
                      )}
                    </p>
                  </div>

                  <VisibilitySensor onChange={changeVisibility} partialVisibility delayedCall>
                    <ContainerCardSkill>
                      <CardSkill text="react.js" classCard="react" img={react} />
                      <CardSkill text="next.js" classCard="nextjs" img={next} />
                      <CardSkill text="angular.js" classCard="angular" img={angular} />
                      <CardSkill text="javascript" classCard="js" img={js} blackText />
                      <CardSkill text="typescript" classCard="ts" img={ts} />
                      <CardSkill text="jquery" classCard="jquery" img={jquery} />
                      <CardSkill text="bootstrap" classCard="bootstrap" img={bootstrap} />
                      <CardSkill text="tailwind" classCard="tailwind" img={tailwind} />
                    </ContainerCardSkill>
                  </VisibilitySensor>

                  <Spacer height="30" />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        {/* APP SECTION */}
        <div className={classes.boxText}>
          <div className={classes.boxHeader}>
            <div className={classes.skillTitleBar}>
              <Container>
                <Row>
                  <div className={classes.titleSkill}>
                    <div className={classes.roundSkill}>
                      <FontAwesomeIcon icon={faMobileScreen} />
                    </div>
                    <div className={classes.titleText}>App</div>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.boxBody}>
            <Container>
              <Row>
                <Col xs={12} lg={12}>
                  <div className="col-12 text-justify text-lg-start pt-3 pb-1">
                    <p className={classes.textSkills}>
                      {lang === "en" ? "Mobile app development using frameworks like Flutter and React Native." : "Sviluppo di app mobili utilizzando framework come Flutter e React Native."}
                    </p>
                  </div>
                  <VisibilitySensor onChange={changeVisibility} partialVisibility delayedCall>
                    <ContainerCardSkill>
                      <CardSkill text="flutter" classCard="flutter" img={flutter} />
                      <CardSkill text="react native" classCard="react" img={react} />
                      <CardSkill text="cordova" classCard="express" img={cordova} />
                    </ContainerCardSkill>
                  </VisibilitySensor>
                  <Spacer height="30" />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        {/* WEB 3D SECTION */}
        <div className={classes.boxText}>
          <div className={classes.boxHeader}>
            <div className={classes.skillTitleBar}>
              <Container>
                <Row>
                  <div className={classes.titleSkill}>
                    <div className={classes.roundSkill}>
                      <FontAwesomeIcon icon={faCube} />
                    </div>
                    <div className={classes.titleText}>Web 3D</div>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.boxBody}>
            <Container>
              <Row>
                <Col xs={12} lg={12}>
                  <div className="col-12 text-justify text-lg-start pt-3 pb-1">
                    <p className={classes.textSkills}>
                      {lang === "en" ? "I've always been passionate about 3D. Experience with Blender, Three.js, React Fiber and Unity." : "Sono appassionato di 3d da sempre. Esperienza con Blender, Three.js, React Fiber e Unity."}
                    </p>
                  </div>
                  <VisibilitySensor onChange={changeVisibility} partialVisibility delayedCall>
                    <ContainerCardSkill>
                      <CardSkill text="three.js" classCard="three" img={three} />
                      <CardSkill text="react fiber" classCard="react" img={react} />
                      <CardSkill text="unity" classCard="express" img={unity} />
                    </ContainerCardSkill>
                  </VisibilitySensor>
                  <Spacer height="30" />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        {/* DEVOPS SECTION */}
        <div className={classes.boxText}>
          <div className={classes.boxHeader}>
            <div className={classes.skillTitleBar}>
              <Container>
                <Row>
                  <div className={classes.titleSkill}>
                    <div className={classes.roundSkill}>
                      <FontAwesomeIcon icon={faGear} />
                    </div>
                    <div className={classes.titleText}>DevOps</div>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.boxBody}>
            <Container>
              <Row>
                <Col xs={12} lg={12}>
                  <div className="col-12 text-justify text-lg-start pt-3 pb-1">
                    <p className={classes.textSkills}>
                      {lang === "en" ? "Skills in versioning tools like Git, AWS deploy, Plesk, Docker, Linux." : "Competenze in Git, AWS, Plesk, Docker, Linux."}
                    </p>
                  </div>
                  <VisibilitySensor onChange={changeVisibility} partialVisibility delayedCall>
                    <ContainerCardSkill>
                      <CardSkill text="plesk" classCard="express" img={plesk} />
                      <CardSkill text="aws" classCard="express" img={aws} />
                      <CardSkill text="git" classCard="git" img={git} />
                      <CardSkill text="docker" classCard="docker" img={docker} />
                      <CardSkill text="kubernates" classCard="kubernates" img={kubernates} />
                    </ContainerCardSkill>
                  </VisibilitySensor>
                  <Spacer height="30" />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <Spacer height={50} />

        {/* OTHERS SECTION */}
        <div className={classes.boxText}>
          <div className={classes.boxHeader}>
            <div className={classes.skillTitleBar}>
              <Container>
                <Row>
                  <div className={classes.titleSkill}>
                    <div className={classes.roundSkill}>
                      <FontAwesomeIcon icon={faForward} />
                    </div>
                    <div className={classes.titleText}>Others</div>
                  </div>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.boxBody}>
            <Container>
              <Row>
                <Col xs={12} lg={12}>
                  <div className="col-12 text-justify text-lg-start pt-3 pb-1">
                    <p className={classes.textSkills}>
                      {lang === "en" ? "Other technologies and tools I use." : "Altre tecnologie e strumenti che utilizzo."}
                    </p>
                  </div>
                  <VisibilitySensor onChange={changeVisibility} partialVisibility delayedCall>
                    <ContainerCardSkill>
                      <CardSkill text="python" classCard="python" img={python} />
                      <CardSkill text="c sharp" classCard="csharp" img={csharp} />
                      <CardSkill text="java" classCard="java" img={java} />
                      <CardSkill text="unity" classCard="express" img={unity} />
                      <CardSkill text="wordpress" classCard="wordpress" img={wordpress} />
                    </ContainerCardSkill>
                  </VisibilitySensor>
                  <Spacer height="30" />
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <Spacer height={50} />

      </div>
    </>
  );
}

export default SkillPage;
